<div class="modal-header">
  <h4 class="modal-title">{{ folder ? "Edit" : "Create" }} Folder</h4>
  <button ngbAutofocus class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body" ngbAutofocus>
  <myp-inline-loader [loading]="loading" height="200px" spinnerName="moveFileLoader"></myp-inline-loader>
  @if (!folder && !loading) {
    <div class="form-group">
      <span class="t-14 d-block">
        {{ "sphere.workspaces.new_folder_in" | translate }}
        <code>{{ parentFolder?.filename || "Home" }}</code>
      </span>
      <small class="text-muted">{{ "sphere.workspaces.name" | translate }}</small>
      <input type="text" class="form-control" (keyup.enter)="submit()" [(ngModel)]="name" />
    </div>
  }
  @if (folder && !loading) {
    <div class="form-group">
      <small class="text-muted">{{ "sphere.workspaces.name" | translate }}</small>
      <input type="text" class="form-control" (keyup.enter)="submit()" [(ngModel)]="name" />
    </div>
  }
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" [disabled]="loading" (click)="submit()">{{ (folder ? "sphere.workspaces.save" : "sphere.workspaces.create") | translate }}</button>
  <button type="button" class="btn btn-blank" (click)="activeModal.close('Close click')">{{ "general.close" | translate }}</button>
</div>
